export const MULTIPLE_PROPS = {
  multipleLimit: {
    type: Number,
    default: 0
  },
  valueKey: String,
  fetchSuggestions: Function,
  labelKeys: Array,
  rowKey: {
    type: String,
  },
  checkAll: {
    type: Boolean,
    default: false
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/props/multiple.js